export default "__VITE_ASSET__M8Ao2zm2__"